import { render, staticRenderFns } from "./Aufgaben.vue?vue&type=template&id=25135014&"
import script from "./Aufgaben.vue?vue&type=script&lang=ts&"
export * from "./Aufgaben.vue?vue&type=script&lang=ts&"
import style0 from "./Aufgaben.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports